const fr = {
  metaTitle: "FearGreed — Bouton Sentiment Crypto",
  metaDescription: "Le Crypto Fear & Greed Index sous forme de bouton tactile. Mises à jour programmées depuis alternative.me. Sans compte, sans traçage.",

  navAbout: "Docs",
  footerPrivacy: "Confidentialité",
  footerSupport: "Support",
  footerAbout: "Docs",
  footerDataSource: "Données : alternative.me · Pas un conseil financier",

  loading: "Chargement…",
  unableToLoad: "Impossible de charger l'indice",
  somethingWentWrong: "Une erreur est survenue.",
  tryAgain: "Réessayer",
  lastUpdated: "Mis à jour {time}",
  updating: "Mise à jour…",
  buttonUpdated: "Mis à jour ✓",
  nowLabel: "{value} ({bucket})",
  sourceLabel: "Source : alternative.me",
  ariaButton: "{value} {bucket} — Indice Fear and Greed. Appuyez pour un insight.",

  ritualDisclaimer: "Pas un conseil financier",

  infoTitle: "Indice Fear & Greed",
  infoDescription: "Score de sentiment du marché crypto (0–100). Volatilité, momentum, réseaux sociaux, sondages. Source : alternative.me. Pas un conseil financier.",
  infoAttribution: "Données de alternative.me Crypto Fear & Greed Index.",
  info7d: "Tendance 7 jours",
  info30d: "Tendance 30 jours",
  infoNextUpdate: "Prochaine mise à jour",
  infoInterpretTitle: "Comment lire",
  infoInterpretExtremeFear: "0–24 : Peur Extrême. A historiquement précédé certaines reprises.",
  infoInterpretExtremeGreed: "75–100 : Avidité Extrême. A historiquement précédé certaines corrections.",
  infoDisclaimer: "Indicateur de sentiment uniquement. Les schémas passés ne prédisent pas les résultats futurs. Faites vos propres recherches.",
  infoApiTitle: "API",
  infoPulseTitle: "Pulse",
  infoDocsLink: "Documentation complète et référence API",

  backToButton: "Retour",

  aboutTitle: "Docs",
  aboutWhatTitle: "Qu'est-ce que FearGreed ?",
  aboutWhat: "Affiche le Crypto Fear & Greed Index — un score de sentiment quotidien (0–100) calculé par alternative.me à partir de la volatilité, du momentum, des réseaux sociaux, des sondages, de la dominance et des tendances. Un signal. Aucun bruit.",
  aboutWhyTitle: "Pourquoi FearGreed ?",
  aboutWhyIntro: "L'indice brut est un nombre. FearGreed le transforme en produit.",
  aboutWhy1Title: "UX ritualisée",
  aboutWhy1: "Un bouton tactile. Pas de graphiques, pas de bruit, pas de tableaux de bord. Appuyez, lisez, avancez.",
  aboutWhy2Title: "Synchronisation programmée",
  aboutWhy2: "Vérifie les nouvelles données via des fenêtres cron programmées, alignées sur le cycle de mise à jour quotidien de la source.",
  aboutWhy3Title: "Analyses dérivées",
  aboutWhy3: "Delta, moyennes mobiles, pente, durée de régime, étiquettes de surveillance — calculés à partir des données brutes, non disponibles depuis la source.",
  aboutWhy4Title: "Pulse en langage naturel",
  aboutWhy4: "Phrase d'insight quotidienne générée par IA. Contextuelle, pas générique.",
  aboutWhy5Title: "Market tape",
  aboutWhy5: "Variations 24h BTC/ETH, capitalisation, dominance, volume et étiquette de pression. Rafraîchi toutes les 4 heures.",
  aboutWhy6Title: "Pour les agents",
  aboutWhy6: "Endpoints JSON structurés, llms.txt, spécification OpenAPI et badge SVG. Conçu pour la consommation programmatique.",
  aboutSourceTitle: "Source des données",
  aboutSource: "Données d'alternative.me. La source se met généralement à jour une fois par jour vers 00:00 UTC. FearGreed vérifie les nouvelles données via des fenêtres cron programmées alignées sur ce calendrier.",
  aboutApiTitle: "API",
  aboutApiDescription: "Endpoints publics. CORS activé. JSON sauf indication contraire. Aucune authentification requise.",
  aboutApiLatest: "Dernière valeur avec analyses dérivées : delta, moyennes, distance du neutre.",
  aboutApiHistory: "30 dernières valeurs quotidiennes avec bucket et couleur.",
  aboutApiSummary: "Résumé en texte brut. Utile pour les LLM et les agents.",
  aboutApiBadge: "Badge SVG. À intégrer dans les README ou les tableaux de bord.",
  aboutApiContext: "Contexte quotidien généré par IA avec indication de tendance et toutes les analyses dérivées. Cache 1h.",
  aboutApiPulse: "Analyses structurées : régime, signal, pente, moyennes. Sans IA. Cache 15min.",
  aboutApiTape: "Variations 24h BTC/ETH, capitalisation, dominance, volume et étiquette de pression. Cache 30min.",
  aboutBadgeTitle: "Badge / Embed statique",
  aboutBadgeDescription: "Intégrez l'indice actuel sous forme de badge SVG :",
  aboutEmbedTitle: "Embed interactif",
  aboutEmbedDescription: "Intégrez le bouton interactif complet dans n'importe quelle page via iframe. Même sensation tactile, sans chrome, données en cache uniquement.",
  aboutCurlTitle: "Exemple de requête",
  aboutJsonExample: "Exemple de réponse (Latest)",
  aboutLlmsTxtTitle: "llms.txt",
  aboutLlmsTxtDescription: "Résumé du projet lisible par les machines pour les agents LLM et les crawlers.",
  aboutOpenapiTitle: "OpenAPI",
  aboutOpenapiDescription: "Spécification API complète au format OpenAPI 3.0.",
  aboutDisclaimerTitle: "Avertissement",
  aboutDisclaimer: "Utilité de sentiment uniquement. Ne prédit pas les mouvements de prix. Pas un conseil financier. Faites vos propres recherches.",
  aboutNonAffiliation: "FearGreed est une interface indépendante. Il n'est ni affilié ni approuvé par alternative.me.",
  staleIndicator: "Hors ligne · données en cache",
  infoButton: "Plus d'informations",
  languageSelector: "Langue",
  themeToggle: "Changer le thème",

  privacyTitle: "Politique de confidentialité",
  privacyEffectiveDate: "Date d'entrée en vigueur : 8 mars 2026",
  privacySummaryTitle: "Résumé",
  privacySummary: "FearGreed ne nécessite pas de connexion, ne crée pas de comptes et ne collecte pas de données personnelles.",
  privacyDataTitle: "Données collectées",
  privacyData: "Aucune. Pas d'inscriptions, pas de cookies de traçage, pas de profils analytiques.",
  privacyTechTitle: "Données techniques",
  privacyTech: "L'infrastructure d'hébergement peut enregistrer des adresses IP et des horodatages pour la fiabilité. Non liés à des utilisateurs individuels.",
  privacyThirdPartyTitle: "Services tiers",
  privacyThirdParty: "FearGreed récupère des données depuis l'API alternative.me. Consultez leur politique de confidentialité.",
  privacyAdsTitle: "Publicité",
  privacyAds: "FearGreed n'affiche pas de publicité.",
  privacyChangesTitle: "Modifications",
  privacyChanges: "Les mises à jour seront publiées sur cette page avec une date d'entrée en vigueur révisée.",
  privacyContactTitle: "Contact",
  privacyContact: "Des questions ? Contactez-nous à",

  supportTitle: "Support",
  supportDescription: "Pour toute question ou problème, contactez-nous à :",

  bucketExtremeFear: "Peur Extrême",
  bucketFear: "Peur",
  bucketNeutral: "Neutre",
  bucketGreed: "Avidité",
  bucketExtremeGreed: "Avidité Extrême",

  pulseLabel: "Pulse :",
  regimeSuffix: "régime {days}j",
  watchFearDeepening: "Peur en Augmentation",
  watchFearStabilizing: "Peur en Stabilisation",
  watchNeutralCompression: "Compression Neutre",
  watchGreedAccelerating: "Avidité en Accélération",
  watchGreedOverheating: "Avidité en Surchauffe",
  watchPossibleReversal: "Inversion Possible",
  watchTrendPersistence: "Tendance Persistante",
  watchRecoveryBuilding: "Reprise en Construction",

  infoRegimePulse: "Régime et Pulse",
  infoMarketTape: "Market Tape",
  infoPressure: "Pression",

  updateAvailable: "Mise à jour disponible",

  aboutViewLlmsTxt: "Voir llms.txt",
  aboutViewOpenapi: "Voir openapi.json",

  // Market pressure labels
  pressureBroadSellOff: "Vente massive",
  pressureUnderPressure: "Sous pression",
  pressureBroadRally: "Rally généralisé",
  pressureRiskAppetite: "Appétit pour le risque en hausse",
  pressureFlat: "Marché plat",
  pressureMixed: "Signaux mixtes",

  notFoundTitle: "Page non trouvée",
  notFoundBack: "Retour à l'accueil",

  hintTap: "appuie ici",
} as const;

export default fr;
